import type { ReactNode } from 'react';
import { QrCode } from 'lucide-react';
import {
  GooglePayIcon,
  PaytmIcon,
  PhonePeIcon,
  UPIIcon,
} from '../components/icons';
import type { UpiMode } from '../hooks/paymentHook.types';

export interface UpiOption {
  mode: UpiMode;
  label: string;
  icon: ReactNode;
}

export const MOBILE_UPI_OPTIONS: UpiOption[] = [
  {
    mode: 'phonepe',
    label: 'PhonePe',
    icon: <PhonePeIcon />,
  },
  {
    mode: 'gpay',
    label: 'Google Pay',
    icon: <GooglePayIcon />,
  },
  {
    mode: 'paytm',
    label: 'Paytm',
    icon: <PaytmIcon />,
  },
  {
    mode: 'bhim',
    label: 'View all',
    icon: <UPIIcon className="h-4 w-5 object-contain" />,
  },
  {
    mode: 'qr',
    label: 'QR code',
    icon: <QrCode className="h-6 w-6 text-[#011E38]" />,
  },
];